var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresencial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.158 14.2675C14.666 14.2675 17.506 11.4244 17.506 7.91946C17.506 4.41448 14.6629 1.57144 11.158 1.57144C7.65297 1.57144 4.80994 4.41448 4.80994 7.91946C4.80994 11.4244 7.65297 14.2675 11.158 14.2675Z",
    stroke: "#593EFF",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3161 24.4286C21.3161 18.8188 16.7679 14.2705 11.158 14.2705C5.54824 14.2705 1 18.8188 1 24.4286",
    stroke: "#593EFF",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresencial);
export default __webpack_public_path__ + "static/media/presencial.20cfd51038c152605e8e67da6ebc61cd.svg";
export { ForwardRef as ReactComponent };